import { render, staticRenderFns } from "./message-list-item.vue?vue&type=template&id=0f61dc9e"
import script from "./message-list-item.vue?vue&type=script&lang=js"
export * from "./message-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f61dc9e')) {
      api.createRecord('0f61dc9e', component.options)
    } else {
      api.reload('0f61dc9e', component.options)
    }
    module.hot.accept("./message-list-item.vue?vue&type=template&id=0f61dc9e", function () {
      api.rerender('0f61dc9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/campaign-scheduling/message-list-item.vue"
export default component.exports